'use client'

import '@/app/ui/css/loader.css';

export default function Loader() {
    return (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[10000]">
            <div className="w-24 h-24 flex justify-center items-center">
                <div className="loader"></div>
            </div>
        </div>
    )
}